<template>
  <div>
    <div class="columns is-multiline">
      <div class="column is-half">
        <!-- 저장 -->
        <div class="btn-group-justify-end">
          <button class="button is-primary" @click="saveData">저장하기</button>
        </div>

        <div class="box">
          <admin-box-item title="듀티 정보">
            <div class="columns is-multiline">

              <div class="column is-full">
                <!-- 그룹 드롭다운 리스트 선택 -->
                <admin-form-item label="*팀 선택">
                  <div v-if="param_group_id!==''">{{ selectedGroup }}</div>
                  <lp-adm-drop-input ref="adminput"
                                     :data.sync="groupList"
                                     :selectVal="selectedGroup"
                                     @onSelect="res => group_id=res.value"
                                     placeholder="팀 선택"
                                     width="160px"
                                     listAlign="center"
                                     style="display:inline-block; margin-right:4px;" v-else></lp-adm-drop-input>
                </admin-form-item>
              </div>

              <div class="column is-full">
                <admin-form-item label="업로드 이미지">
                  <input-img :url.sync="img"/>
                </admin-form-item>
              </div>
            </div>
          </admin-box-item>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
  import LpAdmDropInput from "../../../module/common/LpAdmDropInput";
  import draggable from 'vuedraggable'
  import InputImg from "../../../module/common/InputImg";
  import GroupMixin from "@/mixins/GroupMixin"

  export default {
    name: 'DutyCreate',
    mixins: [
      GroupMixin
    ],
    components: {
      InputImg,
      LpAdmDropInput,
      draggable
    },
    data() {
      return {
        group_id:0,
        groupList: [],
        img: ''
      }
    },
    created() {
      this.init();
      this.getGroupList('groupList');
    },
    computed: {
      selectedGroup() {
        let label = '';
        this.groupList.forEach(item=>{
          if(item.value===this.group_id) {
            label = item.label;
          }
        })
        return label;
      },
    },
    watch: {
      $route() {
        this.init();
      }
    },
    methods: {
      init() {
        this.group_id = this.$route.query.group_id ? parseInt(this.$route.query.group_id) : '';
        if(this.group_id === '')
          this.group_id = this.param_group_id;
        this.img = '';
      },
      saveData() {
        if(this.group_id===0 || this.group_id==='') {
          this.toast('팀을 선택하세요.');
          return;
        }
        if(!this.img || this.img === '') {
          this.toast('파일을 선택하세요.');
          return;
        }
        this.$axios.post(this.getUrl(`group/${this.group_id}/duty`), {
          img: this.img
        }).then(res=>{
          if(res.status===200) {
            this.toast('저장되었습니다.');
            this.$router.replace(this.getPath(`group/duty`));
          }
        })
      }
    }
  }
</script>
<style lang="stylus" type="stylus" scoped>
  @import '~assets/css/lp_main'
</style>
